export default __webpack_public_path__ + "static/Sport-f94cdb03f09e5665491454a17279a677.mp4";